import React, { Component } from 'react';
import { List, Card } from 'semantic-ui-react';

export default class WeaponListContent extends Component {

    render() {

        const {equipment} = this.props;

        if(!equipment.WeaponType || !equipment.DPS) {
            return null;
        }

        const rangeElement = (equipment.Range && equipment.Range > 3) ?
            <List.Item>
                <b>{equipment.Range}</b> meter range
            </List.Item> :
            null;

        return (
            <Card.Content>
                <List.Item>
                    Damage per second <b>{Number(equipment.DPS).toFixed(2)}</b>
                </List.Item>
                <List.Item>
                    <b>{equipment.MinimumDamage}</b>-<b>{equipment.MaximumDamage}</b> damage over <b>{equipment.Speed}</b> seconds
                </List.Item>
                {rangeElement}
            </Card.Content>
        );
    }
}


// WEBPACK FOOTER //
// ./src/items/detail/summary-card/WeaponListContent.jsx